import React from 'react';

export default class Product extends React.Component {

// example
//{ 
//  "sectorName": "Ihly, nože na mandle",
//  "sectorUrl": "/p/redirect-me/bysector-2010",
//  "catalogName": "ORL"
//}

    render() {
        const {props: {sector: {sectorName, sectorUrl, catalogName}}} = this;

        return (
                <li>
                    <a href={sectorUrl} >
                        {sectorName}
                        <span className="catalog" dangerouslySetInnerHTML={{ __html: catalogName }} />
                    </a>                            
                </li>

                );
    }

}


